var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlertTriangle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9998 12.75V18.4166M16.9998 24.0833H17.014M15.0382 5.51323L3.38626 25.6393C2.73997 26.7556 2.41683 27.3138 2.46459 27.7719C2.50624 28.1714 2.71559 28.5345 3.04051 28.7708C3.41303 29.0416 4.05799 29.0416 5.3479 29.0416H28.6517C29.9416 29.0416 30.5866 29.0416 30.9591 28.7708C31.284 28.5345 31.4934 28.1714 31.535 27.7719C31.5828 27.3138 31.2597 26.7556 30.6134 25.6393L18.9614 5.51323C18.3175 4.40092 17.9955 3.84476 17.5754 3.65797C17.209 3.49503 16.7907 3.49503 16.4242 3.65797C16.0041 3.84476 15.6822 4.40092 15.0382 5.51323Z",
    stroke: "#667085",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertTriangle);
export default __webpack_public_path__ + "static/media/alert-triangle.938bf3bce54d57c734b0961ea68a4504.svg";
export { ForwardRef as ReactComponent };